const doc = [({"en":({"js":({"feedback_steps":({"dropdown":({"choose_one_of_the_options":"Choose one of the options"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;